<header>
    <div class="video-hero">
      <video autoplay loop muted>
          <source src="../../assets/hero-video.mp4" type="video/mp4" allow="autoplay">
      </video>
      <div class="video-text">
        <div class="mat-display-2">¡viva la virgen de la nueva!</div>
      </div>
   </div>
</header>

<main>
  <section class="grid">

    <mat-card class="grid-item-anim card-hero">
      <div class="card-hero-div">
        <img mat-card-image class="card-hero-img" src="/assets/home-virgen.jpg" alt="Photo of a Shiba Inu">
        <div class="card-hero-text">
          <mat-card-title>Virgen</mat-card-title>
          <mat-card-subtitle>conoce a la Virgen de la Nueva</mat-card-subtitle>
        </div>  
      </div>
      <button mat-raised-button color="accent" routerLink="/virgen">virgen</button>
    </mat-card>

    <mat-card class="grid-item-anim card-hero">
      <div class="card-hero-div">
        <img mat-card-image class="card-hero-img" src="/assets/home-novena.jpg" alt="Photo of a Shiba Inu">
        <div class="card-hero-text">
          <mat-card-title>Novena</mat-card-title>
          <mat-card-subtitle>reza la Novena a la Virgen de la Nueva</mat-card-subtitle>
        </div>
      </div>
      <button mat-raised-button color="accent" routerLink="/novena">novena</button>
    </mat-card>
  
    <mat-card class="grid-item-anim card-hero">
      <div class="card-hero-div">
        <img mat-card-image class="card-hero-img" src="/assets/home-romeria.jpg" alt="Photo of a Shiba Inu">
        <div class="card-hero-text">
          <mat-card-title>Romería</mat-card-title>
          <mat-card-subtitle>acompaña a la Virgen de la Nueva al lugar donde se encontró</mat-card-subtitle>
        </div>  
      </div>
      <button mat-raised-button color="accent" routerLink="/romeria">romeria</button>
    </mat-card>

    <mat-card class="grid-item-anim card-hero">
      <div class="card-hero-div">
        <img mat-card-image class="card-hero-img" src="/assets/home-museo.jpg" alt="Photo of a Shiba Inu">
        <div class="card-hero-text">
          <mat-card-title>Museo</mat-card-title>
          <mat-card-subtitle>visita la exposición permanente de objetos de la Virgen de la Nueva</mat-card-subtitle>
        </div>  
      </div>
      <button mat-raised-button color="accent" routerLink="/museo">museo</button>
    </mat-card>

  </section>
<!--
  <div class="mat-display-4">shop</div>
    <p>you can buy the entire collection on etsy</p><button mat-raised-button color="accent">ETSY</button>
    <mat-card *ngIf="church | async as church" [routerLink]="[church.id]">
    <p>here is a selection</p>
  -->
  <!--
  <div class="mat-display-4">Raffle</div>
  <mat-card>
    <mat-card-header>
      <mat-card-title>Manto bordado</mat-card-title>
      <mat-card-subtitle>ennamel pin</mat-card-subtitle>
    </mat-card-header>
    <img mat-card-image src="../../../assets/mantilla.jpeg" />
    <mat-card-content>
      <button mat-raised-button>buy on etsy</button>
    </mat-card-content>
  </mat-card>
  -->

</main>